import { render, staticRenderFns } from "./MyAccountControl.vue?vue&type=template&id=216d07e0&scoped=true&"
import script from "./MyAccountControl.vue?vue&type=script&lang=js&"
export * from "./MyAccountControl.vue?vue&type=script&lang=js&"
import style0 from "./MyAccountControl.vue?vue&type=style&index=0&id=216d07e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "216d07e0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!C:/idev/ui_projects/vue/training/topnav-auth-skeleton-1/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib'
installComponents(component, {VAvatar})
